import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CustomOrder, CustomOrderHistory } from '@order/const';
import { OrderService } from '@order/feature';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { Observable, ReplaySubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-order-download-bill',
  templateUrl: './order-download-bill.component.html',
  styleUrls: ['./order-download-bill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, IconModule, SdvorButtonComponent],
})
export class OrderDownloadBillComponent implements OnChanges, OnInit {
  @Input() order: CustomOrderHistory | CustomOrder;
  @Input() large = false;

  loading$: Observable<boolean>;

  private orderIdSubject$ = new ReplaySubject<string>(1);

  constructor(private orderService: OrderService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.order) {
      this.orderIdSubject$.next(this.order?.guid);
    }
  }

  ngOnInit(): void {
    this.loading$ = this.orderIdSubject$.pipe(
      switchMap((orderId) => this.orderService.getOrderInvoicePaymentLoading(orderId)),
    );
  }

  onClickButtonBill(): void {
    this.orderService.downloadOrderInvoicePayment(this.order.guid, this.order.code);
  }
}
